module.exports = __webpack_public_path__ + "static/media/pc3.2e0b3d58.png";